import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import LinesEllipsis from 'react-lines-ellipsis'
import { FoldedTextEl } from './elements'
import { useToggle } from '../../Helpers/CustomHooks/useToggle'
import { Button } from '@material-ui/core'

const FoldedText = ({ children, maxLines, ...props }) => {
  const container = useRef()

  const [showAll, toggle] = useToggle(false)
  const [isClamped, setIsClamped] = useToggle(false)

  return (
    <FoldedTextEl>
      <LinesEllipsis
        ref={container}
        text={children}
        maxLine={showAll ? Infinity : maxLines}
        ellipsis='...'
        onReflow={() => setIsClamped(Boolean(container.current?.isClamped()))}
        /* eslint-disable-next-line react/jsx-props-no-spreading */
        {...props}
      />
      {(showAll || isClamped) && (
        <Button
          onClick={() => {
            toggle()
          }}
        >
          {showAll ? `Read Less` : `Read More`}
        </Button>
      )}
    </FoldedTextEl>
  )
}

export default FoldedText

FoldedText.propTypes = {
  children: PropTypes.string.isRequired,
  maxLines: PropTypes.number.isRequired,
}
